// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"1441e516","92":"ae921b0c","521":"0d616c6d","778":"925e9df5","965":"831f3114"}[chunkId] + ".chunk.js";
};